import React, { createContext, useContext, useState } from "react";
import Snackbar from "@material-ui/core/Snackbar";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { amber, blue, green, red } from "@material-ui/core/colors";

const SnackbarContext = createContext();

const severityStyles = {
  success: { backgroundColor: green[600], color: "#fff" },
  error: { backgroundColor: red[700], color: "#fff" },
  warning: { backgroundColor: amber[700], color: "#fff" },
  info: { backgroundColor: blue[700], color: "#fff" },
};

export const SnackbarProvider = ({ children }) => {
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const showSnackbar = (message, severity = "success") => {
    setSnackbarState({ open: true, message, severity });
  };

  showSnackbar.hide = () => {
    setSnackbarState((prev) => ({ ...prev, open: false }));
  };

  const handleClose = (_, reason) => {
    if (reason === "clickaway") return;
    showSnackbar.hide();
  };

  const contentStyle =
    severityStyles[snackbarState.severity] || severityStyles.info;

  return (
    <SnackbarContext.Provider value={showSnackbar}>
      {children}
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={snackbarState.open}
        autoHideDuration={6000}
        onClose={handleClose}
      >
        <SnackbarContent
          style={{ ...contentStyle, minWidth: 280 }}
          message={<span>{snackbarState.message}</span>}
          action={
            <IconButton
              size="small"
              style={{ color: "#fff" }}
              aria-label="close"
              onClick={showSnackbar.hide}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          }
        />
      </Snackbar>
    </SnackbarContext.Provider>
  );
};

export const useSnackbar = () => useContext(SnackbarContext);
